import { createAction } from 'redux-act';
//////////////////////////////////////////////////

const getAppReleaseSuccess = createAction('getAppReleaseSuccess');
const createAppReleaseRequest = createAction('createAppReleaseRequest');
const createAppReleaseSuccess = createAction('createAppReleaseSuccess');
const updateAppReleaseRequest = createAction('updateAppReleaseRequest');
const updateAppReleaseSuccess = createAction('updateAppReleaseSuccess');

export {
  getAppReleaseSuccess,
  createAppReleaseRequest,
  createAppReleaseSuccess,
  updateAppReleaseRequest,
  updateAppReleaseSuccess,
};
